import { cn } from "@/libs/utils";
import Image from "next/image";

export default function SkillCard({
  iconUrl,
  name,
  percent,
  index,
  hovered,
  setHovered,
}: {
  iconUrl: string;
  name: string;
  percent: string;
  index: number;
  hovered: number | null;
  setHovered: React.Dispatch<React.SetStateAction<number | null>>;
}) {
  return (
    <div
      onMouseEnter={() => setHovered(index)}
      onMouseLeave={() => setHovered(null)}
      className={cn(
        "bg-[#ffffffeb] hover:bg-[#fff] dark:bg-[#242424b6] shadow-[0px_0px_15px_rgba(0,0,0,0.09)] px-5 py-9 space-y-3 relative overflow-hidden transition-all duration-300 ease-out md:h-auto",
        hovered !== null && hovered !== index && "blur-sm scale-[0.98]"
      )}
    >
      <div className="w-20 h-20 bg-violet-500 rounded-full absolute -right-5 -top-7">
        <p className="absolute bottom-4 left-3 text-white font-bold text-lg">
          {percent}
        </p>
      </div>
      <div className="flex gap-2 flex-col lg:flex-row">
        <div className="w-2/5">
          <div className="w-12 h-12">
            <Image
              alt={name}
              src={iconUrl}
              width={0}
              height={0}
              sizes="100vw"
              className="w-full h-full"
            />
          </div>
          <h3 className="font-bold text-base whitespace-nowrap">{name}</h3>
        </div>
      </div>
    </div>
  );
}
